var config = {

  // apiUrl: 'http://192.168.110.196:8126/',//接口 
  // fileShowUrl:'http://192.168.110.196:8126',

  // apiUrl: 'http://127.0.0.1:8126/',//接口 
  // fileShowUrl:'http://127.0.0.1:8126',

  //测试
  // apiUrl: 'https://ft.fzjiading.com/mbyqhapi',//接口 
  // fileShowUrl:'https://ft.fzjiading.com/mbyqhapi',

  //正式
  apiUrl: 'https://www.npgas.cn/api/',//接口 
  fileShowUrl:'https://www.npgas.cn/api/',
};

export default config;


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = null
// module chunks = 